@if (toastService.current(); as toast) {
  <div
    class="toast"
    [class.toast--leaving]="toastService.isLeaving()"
    [class.toast--success]="toast.type === 'success'"
    [class.toast--error]="toast.type === 'error'"
    role="status"
    aria-live="polite"
  >
    <span class="toast__icon">
      @if (toast.type === 'success') { ✓ }
      @else if (toast.type === 'error') { ✕ }
      @else { ℹ }
    </span>
    <span class="toast__text">{{ toast.text }}</span>
    <button
      type="button"
      class="toast__close"
      aria-label="Chiudi messaggio"
      (click)="toastService.dismiss()"
    >✕
    </button>
  </div>
}
